// extracted by mini-css-extract-plugin
export default {"paper":"TextSpacing_paper__qr1BL","container":"TextSpacing_container__HH2wA"};